import $ from 'jquery';
import { Dispatcher } from 'barba.js';
import { addMetadataHook } from '../pjax';
import { getScrollTop, onScroll } from '../utils/window';

export default function overlaySection() {
	const $html = $('html');
	const $scroller = $('html, body');
    const $overlay = $('#overlay');


    // $overlay.show().promise().done(function(){
    //     $overlay.addClass('is-open--middle');
    // });

    setTimeout(()=>{
        $overlay.addClass('is-open--middle');
    }, 200);

    $(document).ready(function () {
        setTimeout(() => {

            $overlay.addClass('is-open--last');

            setTimeout(() => {
                // after the fade out is complete make the overlay display none.
                $overlay.css('display', 'none');
                $overlay.removeClass('is-open--middle');
                $overlay.removeClass('is-open--last');
            }, 1000);
        }, 1500);
    });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/overlay.js